import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// NOTE: Global CSS is intentionally NOT imported here.
// PublicLayout loads public/styles/public.css for the marketing site,
// AdminApp loads App.css for the clinic software — so the two design systems
// don't fight over :root / body selectors.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
